import React from 'react';
import { ArrowDownIcon, ArrowRightIcon } from 'lucide-react';
import { CHECKOUT_URL, ctaLabel, offer } from '../data/content';
import { trackPixel } from '../utils/metaPixel';
type CtaButtonProps = {
  /** 'scroll' smooth-scrolls to #offer (no tracking). 'checkout' is ONLY for the offer section button. */
  action?: 'scroll' | 'checkout';
  label?: string;
  microcopy?: string;
  microTone?: 'light' | 'dark';
  align?: 'start' | 'center';
};
export function scrollToOffer() {
  const el = document.getElementById('offer');
  if (!el) return;
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  el.scrollIntoView({
    behavior: reduce ? 'auto' : 'smooth',
    block: 'start'
  });
}
export function handleScrollClick(e: React.MouseEvent<HTMLAnchorElement>) {
  e.preventDefault();
  scrollToOffer();
}
function handleCheckoutClick(e: React.MouseEvent<HTMLAnchorElement>) {
  trackPixel('InitiateCheckout');
  if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0) return;
  e.preventDefault();
  window.setTimeout(() => {
    window.location.href = CHECKOUT_URL;
  }, 180);
}
export function CtaButton({
  action = 'scroll',
  label,
  microcopy,
  microTone = 'dark',
  align = 'start'
}: CtaButtonProps) {
  const isCheckout = action === 'checkout';
  const text = label ?? (isCheckout ? offer.cta : ctaLabel);
  const Icon = isCheckout ? ArrowRightIcon : ArrowDownIcon;
  return <div className={`flex w-full flex-col gap-3 ${align === 'center' ? 'items-center text-center' : 'items-center text-center sm:items-start sm:text-left'}`} data-id="element-56" data-mp="3ov8py5v8b963">
      <a href={isCheckout ? CHECKOUT_URL : '#offer'} onClick={isCheckout ? handleCheckoutClick : handleScrollClick} data-cta={isCheckout ? 'checkout' : 'offer'} className="group inline-flex min-h-[58px] w-full items-center justify-center gap-2.5 rounded-xl bg-sun px-4 py-3 text-center font-display text-[15px] font-extrabold leading-tight tracking-[0.02em] text-ink shadow-cta transition-[background-color,transform] duration-150 ease-out hover:bg-sun-hover active:translate-y-[2px] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-brand sm:w-auto sm:whitespace-nowrap sm:px-8 sm:text-[16px]" data-id="element-57" data-mp="1ifvllfgd8m4">
        {text}
        <Icon className={`h-[18px] w-[18px] shrink-0 transition-transform duration-150 ease-out ${isCheckout ? 'group-hover:translate-x-0.5' : 'group-hover:translate-y-0.5'}`} strokeWidth={2.75} aria-hidden="true" data-id="element-58" data-mp="3rw0fuaw7dv3n" />
      </a>
      {microcopy && <p className={`text-[13px] font-medium leading-snug ${microTone === 'light' ? 'text-white/85' : 'text-ink/65'}`} data-id="element-59" data-mp="jggsttm4l8x1">{microcopy}</p>}
    </div>;
}